import { render, staticRenderFns } from "./OpeningSensorDevice.vue?vue&type=template&id=73b960f0"
import script from "./OpeningSensorDevice.vue?vue&type=script&lang=js"
export * from "./OpeningSensorDevice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports